import * as types from './mutations'
import Vue from 'vue'

function getLocalStoreItem(key, def)
{
    const val = localStorage.getItem(key)
    if (val
        && val != 'undefined'
        && val != ''
        && val != 'null')
        {
            return val
        }
    return def
}

const state = {
    token: getLocalStoreItem('token', null),
    user: JSON.parse(getLocalStoreItem('user', '{}')),
    checked: false,
}

const mutations = {

    [types.SET_TOKEN] (state, token)
    {
        state.token = token
        localStorage.setItem('token', state.token)
    },

    [types.SET_USER] (state, user)
    {
        state.user = user
        state.checked = true
        localStorage.setItem('user', JSON.stringify(state.user))
    },

    [types.CLEAR] (state)
    {
        state.user = {}
        state.token = null
        state.checked = false
        localStorage.removeItem('token')
        localStorage.removeItem('user')
    },
}

const actions = {

    init()
    {

    },

    logout({commit})
    {
        commit(types.CLEAR)
    },

    authLogin({dispatch, commit}, payload)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.post('/auth/login', payload)
                commit(types.SET_TOKEN, response.data.token)
                commit(types.SET_USER, response.data.user)
                resolve(response.data)
            } catch (e) {
                dispatch('logout')
                reject(e)
            }
        })
    },

    authFetch({dispatch, commit, getters})
    {
        return new Promise(async(resolve, reject) => {
            if (getters.authLoggedIn)
            {
                try {
                    const response = await Vue.axios.get('/user')
                    commit(types.SET_USER, response.data)
                    resolve(response.data)
                } catch (e) {
                    dispatch('logout')
                    reject(e)
                }
            }
            reject()
        })
    },

    authCheck({dispatch, getters})
    {
        return new Promise(async(resolve, reject) => {
            if (getters.authLoggedIn)
            {
                if (!getters.authChecked)
                {
                    try {
                        const response = await dispatch('authFetch')
                        resolve(response.data)
                    } catch (e) {
                        reject(e)
                    }
                } else {
                    resolve(getters.authUser)
                }
            }
            reject()
        })
    },

    authForgotPassword({commit}, payload)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.post('/auth/forgot', payload)
                resolve(response.data)
            } catch (e) {
                const error = e && e.response && e.response.data ? e.response.data : {}
                reject(error)
            }
        })
    },

    authResetPassword({commit}, payload)
    {
        return new Promise(async(resolve, reject) => {
            try {
                const response = await Vue.axios.post('/auth/reset', payload)
                resolve(response.data)
            } catch (e) {
                const error = e && e.response && e.response.data ? e.response.data : {}
                reject(error)
            }
        })
    },

}

const getters = {
    authLoggedIn: state => state.token && state.token != 'null',
    authUser: state => JSON.parse(JSON.stringify(state.user)),
    authToken: state => JSON.parse(JSON.stringify(state.token)),
    authChecked: state => state.checked,
}

export default {
    state,
    mutations,
    getters,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js